<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<p class="nonindentj"><span epub:type="pagebreak" id="pagevi" title="vi"></span><span epub:type="pagebreak" id="pagevii" title="vii"></span></p>
<figure id="mapvii">
<p class="center0"><img alt="" src="OEBPS/images/vii-1.jpg"/></p>
</figure>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?4f97c66a